<template>
	<div class="form-floating google-map-ac">
		<input type="text"
		       v-model="formatted_address"
		       autocomplete="new-password"
		       @blur="onBlur"
		       class="form-control ac-input" :placeholder="$t('Enter address')"/>
        <label class="form-label">{{$t('Address')}}  <abbr class="required" title="required">*</abbr></label>
		<button type="button" class="gma-clear"
		        v-if="formatted_address"
		        @click="clear"
		><i class="ri-close-line"></i></button>
		<div class="gma-results">
			<template v-if="predictions.length" >
				<div
					v-for="prediction in predictions"
					:key="prediction.place_id"
					@click="onPredictionSelect( prediction )"
					class="gma-item" :data-placeid="prediction.place_id">
					<span class="gma-icon gma-icon-marker"></span>
					<span class="gma-item-query">{{ prediction.text }}</span>
				</div>
			</template>
		</div>
	</div>
</template>

<script setup>
import {onMounted, ref} from "vue";
import Address from "../../../../vendor/xkit/google-maps/models/address";
import _debounce from "lodash/debounce";
import GoogleMapsHelper from "../../../../vendor/xkit/google-maps/google-maps-helper";

const props = defineProps({
	wrapper_id: String,
	data: Object
})

let $ = jQuery
// let root = ref(null)
let $root, $autocomplete, $resultsDropdown = null
let predictions = ref( [] )
// let formatted_address = ref( '' )

let address = props.data.address
if ( ! address ) {
	address = new Address()
} /*else {
	onPredictionSelect(address.uid)
}*/

let formatted_address = ref( address.formatted_address )

// if ( address == null ) {
// 	address = new Address()
// }
// console.log(address)

const emit = defineEmits(['on-place-changed'])

let sessionToken = null
async function initAC(){
	const { AutocompleteSuggestion } = await GoogleMapsHelper.getPlacesService();
	sessionToken = new google.maps.places.AutocompleteSessionToken();


// listen for address input
	$autocomplete.on('input', _debounce(async function (e) {
		let search = $autocomplete.val()
		if( search && search.length > 2 ) {
			// Perform the query and display the results.
			try {
				const {suggestions, status} =
					await AutocompleteSuggestion.fetchAutocompleteSuggestions( {
						input: $autocomplete.val(),
						// componentRestrictions: { country: "US" },
						sessionToken: sessionToken,
						region: "us",
						// types: ['(regions)'],
					} );

				let items = []
				for ( const suggestion of suggestions ) {
					const placePrediction = suggestion.placePrediction;
					items.push( {place_id: placePrediction.toPlace().id, place: placePrediction.toPlace(), text: placePrediction.text.toString(), suggestion: suggestion, } )
				}

				//Fill results dropdown
				predictions.value = items
				if(predictions.value.length){
					$resultsDropdown.show();
				}
			} catch ( e ) {
				predictions = []
				$resultsDropdown.hide()
			}

			// autoCompletcallBack( items, status)
			// autocompleteService.getPlacePredictions({
			// 	input: $autocomplete.val(),
			// 	componentRestrictions: { country: "US" },
			// 	sessionToken: sessionToken,
			// 	// types: ['(regions)'],
			//
			// },autoCompletcallBack);
		} else {
			// hide dropdown
			$resultsDropdown.hide();
		}
		//throttle call to avoid call google API every time a key is pressed
	}, 400));

	$autocomplete.on('keyup',  onKeyUp )
}

onMounted(function(){
	$root = jQuery( '#' + props.wrapper_id );//jQuery(root.value);
	$autocomplete = jQuery('.ac-input', $root);
	$resultsDropdown = jQuery('.gma-results', $root);

	initAC()
})

let autoCompletcallBack = function( res_predictions, status ){
// google.maps.places.PlacesServiceStatus.ZERO_RESULTS
	if (status != google.maps.places.PlacesServiceStatus.OK) {
		predictions = []
		console.log(status);
		$resultsDropdown.hide()
		return;
	}
	//Fill results dropdown
	predictions.value = res_predictions
	if(predictions.value.length){
		$resultsDropdown.show();
	}
}

let onPredictionSelect = async function(prediction){
	$resultsDropdown.hide();
	// address.uuid = item.dataset.placeid;
	address.uid = prediction.place.id;
	// $autocomplete.val( item.find('.gma-item-query').text() )

	console.log($root.parents('form').find('button[type="submit"]'));
	let $submit = $root.parents('form').find('button[type="submit"]');

	XKIT_Utils.blockUI( $root, 'small', false, true )
	XKIT_Utils.blockSubmit( $submit );

	// Show the first predicted place.
	// let place = suggestions[0].placePrediction.toPlace();

	await prediction.place.fetchFields({
		fields: ['displayName', 'addressComponents', 'types', 'formattedAddress', 'location'], //["displayName", "formattedAddress"],
	});
	refreshToken();

	$root.unblock()

	XKIT_Utils.unblockSubmit( $submit );
	// GoogleMapsHelper.getPlace( prediction.place_id, function(res) {
	// 	console.log(res)	//
	// } )
	setAddressFromGACPlace( prediction.place )


}
// Helper function to refresh the session token.
function refreshToken() {
	// Create a new session token and add it to the request.
	sessionToken = new google.maps.places.AutocompleteSessionToken();
}

/**
 * When a place changed
 */
let setAddressFromGACPlace = function(place) {
	let ui_address = GoogleMapsHelper.map_server_address( place )
	if ( ! place ) {
		address = ui_address
	} else {
		if ( ui_address.formatted_address != address.formatted_address ) {

			let $before_event = new jQuery.Event( 'gac-before-place-change', { cancelable: true })
			$root.trigger($before_event, ui_address )

			if ( $before_event.isDefaultPrevented() ) {
				return
			}
			address = ui_address
		}
	}

	formatted_address.value = address.formatted_address
	// could refactor this to also send the hidden input selector
	// let input_selector = 'input[name="' + props.input + '"]'
	let input_selector = '#' + props.data.input + ''
	// set hidden input
	if ( address.formatted_address ) {
		jQuery( input_selector ).val( JSON.stringify( address ) )
	} else {
		jQuery( input_selector ).val( '' )
	}

	emit('on-place-changed', address)
	$root.trigger('gac-place-changed', address )
}

let onKeyUp = function(e) {
	//Capture keydown & keyup to select item inside results dropdown
	var $listItems = $resultsDropdown.children();

	var key = e.keyCode;
	var $selected = $listItems.filter('.gma-item-selected');
	var $current;

	$listItems.removeClass('gma-item-selected');

	if ( key == 40 ) { // Down key

		if($listItems.length > 0 && $autocomplete.val()) {
			$resultsDropdown.show();
		}
		else {
			return;
		}

		if ( ! $selected.length || $selected.is(':last-child') ) {
			$current = $listItems.eq(0);
		}
		else {
			$current = $selected.next();
		}

		$current.addClass('gma-item-selected');

	} else if ( key == 38 ) {  // Up key
		if($listItems.length > 0 && $autocomplete.val()) {
			$resultsDropdown.show();
		}

		if ( ! $selected.length || $selected.is(':first-child') ) {
			$current = $listItems.last();
		}
		else {
			$current = $selected.prev();
		}

		$current.addClass('gma-item-selected');

	} else if (key == 13) { // Enter
		if($selected.length > 0){
			onPredictionSelect($selected.eq(0));
		}
	}
}
let onBlur = function(){
	// If user clears input, make sure to dispatch action
	if ( formatted_address.value == '' && address.formatted_address != null ) {
		setAddressFromGACPlace( null )
	}
}
let clear = function(){
	setAddressFromGACPlace( null )
}

//
// use_current_location(){
// 	let vm = this
// 	AddressAutocomplete.get_current_location( function( place ) {
// 		// Lets reset the geolocation place type. It comes as a 'street'
// 		place.types = [ 'locality' ]
// 		vm.setAddressFromGACPlace( place )
// 	}, function(){
// 		//handleLocationError(true, infoWindow, map.getCenter());
// 	})
// }

//Close dropdown result on click outside
$(document).click(function(event) {

	if($(event.target).is($autocomplete)) {
		var $listItems =$resultsDropdown.children();
		if($listItems.length > 0 && $autocomplete.val()) {
			$resultsDropdown.show();
		}
	} else {
		// hide dropdown
		$resultsDropdown.hide();
	}
});
</script>